module.exports = __webpack_public_path__ + "media/images/rank/silver-c036a03c15945ee561a100abaa492800.png";